import React, { Component } from 'react';
import { Configurations } from '../../Utils/Configurations';
import ReactTable from 'react-table';

class TableClients extends Component {

    constructor(props) {
        super(props);

        // this.refreshTable = this.refreshTable.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            listaBuscaMembro: this.props.listaBuscaMembro,
            pages: this.props.pages,
            loading: this.props.loading,
            rowSelected: -1
        }

        this.niveis = ["coordenadoria", "sub", "rm", "area", "regional", "distrito", "comunidade", "bloco"];

        this.columns = [
            {
                Header: 'Nome',
                accessor: 'nome',
                className: 'text-left',
                width: 250
            },
            {
                Header: 'Cod.Membro',
                accessor: 'codMembro',
                className: 'pointer text-center',
                width: 100,
                Cell: row => (<span className={row.value ? '' : 'badge badge-secondary'}>{!!row.value ? row.value : 'Não membro'}</span>)
            },
            {
                Header: 'Divisão',
                accessor: 'divisao',
                className: 'text-center',
                width: 90
            },
            {
                Header: 'Organização',
                className: 'text-left',
                Cell: row => {
                    const _arrayOrg = [];
                    this.niveis.forEach(item => {
                        const _org = row.original[item];
                        if(_org) {
                            _arrayOrg.push(_org);
                        }
                    })
                    return (
                        <p className="m-0">{_arrayOrg.join(' / ')}</p>
                    )
                },
                width: 520
            },
            {
                Header: '',
                className: 'text-center text-success',
                Cell: row => <div onClick={() => this.props.selecionaAssinante(row.original)} className="pointer"><i className="fas fa-check"></i></div>,
                // width: 90
            },
        ]

    }

    render() {
        return (
            <div className="row table-clients">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body p-0">
                            <ReactTable
                                data={this.props.listaBuscaMembro}
                                columns={this.columns}
                                onFetchData={this.refreshTable}
                                defaultPageSize={5}
                                pages={this.state.pages}
                                manual
                                loading={this.state.loading}
                                className="-striped -highlight"
                                headerClassName="ebs-table-header"
                                previousText='Anterior'
                                nextText='Próximo'
                                loadingText='Carregando...'
                                noDataText='Nenhum membro encontrado.'
                                pageText='Página'
                                ofText='de'
                                rowsText='linhas'
                            />

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TableClients;